import { RouteObject } from 'react-router';
import ProductionPhaseListPage from './pages/productionphase/list';
import ProductionPhaseUpdatePage from './pages/productionphase/update';
import { AddUpdate } from '@/const';
import NncListPage from './pages/nnc/list';
import NncUpdatePage from './pages/nnc/update';
import EntriesListPage from './pages/entries/list';
import EntriesUpdatePage from './pages/entries/update';
import OriginListPage from './pages/origin/list';
import OriginUpdatePage from './pages/origin/update';
import CauseListPage from './pages/cause/list';
import CauseUpdatePage from './pages/cause/update';
import MachineListPage from './pages/machine/list';
import MachineUpdatePage from './pages/machine/update';
import AnalysisListPage from './pages/analysis/list';
import AnalysisUpdatePage from './pages/analysis/update';
import FailModeListPage from './pages/failmode/list';
import FailmodeUpdatePage from './pages/failmode/update';
import ActionPlansListPage from './pages/actionplan/list';
import ActionPlanUpdatePage from './pages/actionplan/update';
import ActionPlanActionsListPage from './pages/actionplanactions/list';
import TasksPage from './pages/mytasks/tasks';
import NNCReportPage from './pages/report/list';
import NNCEntriesReportPage from './pages/report/listEntries';
import FunctionalAreaListPage from './pages/functionalarea/list';
import FunctionalAreaUpdatePage from './pages/functionalarea/update';

export const routes: RouteObject[] = [
  {
    path: 'nnc',
    children: [
      {
        path: 'productionphase',
        element: (
          <ProductionPhaseListPage appName={'nnc'} model={'productionphase'} />
        ),
      },
      {
        path: `productionphase${AddUpdate}`,
        element: (
          <ProductionPhaseUpdatePage
            appName={'nnc'}
            model={'productionphase'}
          />
        ),
      },
      {
        path: 'entries',
        element: <EntriesListPage appName={'nnc'} model={'nncenrichment'} />,
      },
      {
        path: `entries${AddUpdate}`,
        element: <EntriesUpdatePage />,
      },
      {
        path: 'management',
        element: <NncListPage appName={'nnc'} model={'nnc'} />,
      },
      {
        path: `nnc${AddUpdate}`,
        element: <NncUpdatePage appName={'nnc'} model={'nnc'} />,
      },
      {
        path: 'origin',
        element: <OriginListPage appName={'nnc'} model={'origin'} />,
      },
      {
        path: `origin${AddUpdate}`,
        element: <OriginUpdatePage appName={'nnc'} model={'origin'} />,
      },
      {
        path: 'cause',
        element: <CauseListPage appName={'nnc'} model={'cause'} />,
      },
      {
        path: `cause${AddUpdate}`,
        element: <CauseUpdatePage appName={'nnc'} model={'cause'} />,
      },
      {
        path: 'machine',
        element: <MachineListPage appName={'localization'} model={'machine'} />,
      },
      {
        path: `machine${AddUpdate}`,
        element: (
          <MachineUpdatePage appName={'localization'} model={'machine'} />
        ),
      },
      {
        path: 'criticalanalysis',
        element: (
          <AnalysisListPage appName={'nnc'} model={'criticalanalysis'} />
        ),
      },
      {
        path: `criticalanalysis${AddUpdate}`,
        element: <AnalysisUpdatePage />,
      },
      {
        path: 'failuremode',
        element: <FailModeListPage appName={'nnc'} model={'failuremode'} />,
      },
      {
        path: `failuremode${AddUpdate}`,
        element: <FailmodeUpdatePage />,
      },
      {
        path: 'actionplan',
        element: <ActionPlansListPage appName={'nnc'} model={'actionplan'} />,
      },
      {
        path: `actionplan${AddUpdate}`,
        element: <ActionPlanUpdatePage />,
      },
      {
        path: 'actionplanitem',
        element: (
          <ActionPlanActionsListPage appName={'nnc'} model={'actionplanitem'} />
        ),
      },
      {
        path: 'tasks',
        element: <TasksPage />,
      },
      {
        path: 'report',
        element: <NNCReportPage />,
      },
      {
        path: 'report-nnc',
        element: <NNCEntriesReportPage />,
      },
      {
        path: 'functionalarea',
        element: (
          <FunctionalAreaListPage appName={'nnc'} model={'functionalarea'} />
        ),
      },
      {
        path: `functionalarea${AddUpdate}`,
        element: (
          <FunctionalAreaUpdatePage appName={'nnc'} model={'functionalarea'} />
        ),
      },
    ],
  },
];
